<template>

  <div class="card">
    <div class="card-body">
      <div v-if="loading">
        <b-row>
          <b-col>
            <b-spinner label="Spinning"></b-spinner>
            <p>Exporting Data, this might take up to several minutes...</p>
          </b-col>
        </b-row>
      </div>
      <b-row v-if="readyForDownload">
        <b-col>
          <p>Data was exported {{excelExport.exportTime}},<br /> click the button to download the excel file:</p>
          <b-button variant="primary" @click="download">Download Excel</b-button>
        </b-col>
      </b-row>
      <b-row v-if="canRegenerate">
        <b-col>
          <p>To recreate the excel file with the latest data:</p>
          <b-button   @click="generate">
            Export Now
          </b-button>

        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>

import {BackendApiService} from '../services/BackendApiService'

export default {
  name: 'data-export',
  props: ['schema'],
  data () {
    return {
      success: false,
      excelExport: {},
      loading: false
    }
  },
  computed: {
    readyForDownload: function () {
      return !this.loading && this.excelExport != null && this.excelExport.status === 'READY_FOR_DOWNLOAD'
    },
    canRegenerate: function () {
      return !this.loading && (this.excelExport == null || this.excelExport.status !== 'GENERATING')
    }
  },
  methods: {
    generate () {
      this.loading = true
      BackendApiService.generateExcelData(this.schema.id)

        .then(response => {
          console.log('received response: ' + response.data)
          this.loading = false
          this.success = true
          this.excelExport = response.data
        })
        .catch((e) => {
          this.progress = 0
          this.message = e.response.data.message
          this.loading = false
        })
    },
    download () {
      let href = window.location.origin + '/api/downloadExcelData/' + this.excelExport.id
      window.location.href = href
    }
  },
  mounted () {
    console.log('mounted')
    BackendApiService.getExport(this.schema.id).then(response => {
      this.excelExport = response.data
      console.log(this.excelExport)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DataExport.vue